// Google Ads conversion tracking helpers.
// Conversion action ID from Google Ads → Tools → Conversions.
export const GOOGLE_ADS_CONVERSION_ID = "AW-18251623721/bkCtCMLomMocEKnahv9D";

/**
 * Fires a Google Ads conversion event.
 * Safe to call before gtag has loaded — will simply no-op.
 *
 * @param {object} [opts]
 * @param {string} [opts.transactionId] - Optional unique ID to prevent duplicate conversions.
 * @param {number} [opts.value] - Optional monetary value for the conversion.
 * @param {string} [opts.currency='USD'] - Currency code for the value.
 */
export const trackConversion = ({ transactionId = "", value, currency = "USD" } = {}) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;

  const payload = {
    send_to: GOOGLE_ADS_CONVERSION_ID,
    transaction_id: transactionId,
  };
  if (typeof value === "number") {
    payload.value = value;
    payload.currency = currency;
  }
  window.gtag("event", "conversion", payload);
};

/**
 * Fires when a visitor taps a phone-call button.
 * Passes a rough value estimate for a phone lead ($50 default).
 */
export const trackCallConversion = (source = "call_button") => {
  trackConversion({
    transactionId: `call-${Date.now()}`,
    value: 50,
  });
  if (window.gtag) {
    window.gtag("event", "call_click", {
      event_category: "engagement",
      event_label: source,
    });
  }
};

/**
 * Fires when a visitor submits the contact form successfully.
 * Passes a form-lead value estimate ($75 default).
 */
export const trackFormConversion = (submissionId) => {
  trackConversion({
    transactionId: submissionId || `form-${Date.now()}`,
    value: 75,
  });
};
